export const ORDER_CALCULATOR_LABEL = 'مبلغ سفارش';
export const ORDER_QUANTITY_LABEL = 'تعداد';
export const ORDER_MAX_LABEL = 'حداکثر';
export const ORDER_MIN_LABEL = 'حداقل';

/** Toast when user tries to drag sell % slider without sellable assets */
export const NO_SELLABLE_ASSET_TOAST = 'شما روی این نماد، دارایی قابل فروش ندارید.';

/** Toast when user tries to drag buy % slider without buying power */
export const NO_BUYING_POWER_TOAST = 'قدرت خرید شما برای این نماد صفر است.';
